import { render } from "./TestGroupStudents.vue?vue&type=template&id=41cc8c0a"
import script from "./TestGroupStudents.vue?vue&type=script&lang=js"
export * from "./TestGroupStudents.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__